import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { App } from './App';
import { store } from './store';
import { ArchiveThemeProvider } from './theme/ThemeModeProvider';
import './styles.css';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element is missing');
}

createRoot(root).render(
  <StrictMode>
    <Provider store={store}>
      <ArchiveThemeProvider>
        <App />
      </ArchiveThemeProvider>
    </Provider>
  </StrictMode>
);
